
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { formatDate } from "@/utils/date";
import type { WinnersTableProps } from "./types";

const formatDeviceInfo = (deviceInfo: any) => {
  if (!deviceInfo || typeof deviceInfo !== 'object') return "No device info";
  const info = deviceInfo as Record<string, any>;
  return Object.entries(info)
    .map(([key, value]) => `${key}: ${value}`)
    .join(', ');
};

export function WinnersTable({ winners, onDelete, deletingId }: WinnersTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Timestamp</TableHead>
          <TableHead>Prize</TableHead>
          <TableHead>Vote/Tip</TableHead>
          <TableHead>Source</TableHead>
          <TableHead>Device Info</TableHead>
          <TableHead>Claimed</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {winners.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} className="text-center py-4">
              No prize allocations logged yet
            </TableCell>
          </TableRow>
        ) : (
          winners.map((winner) => (
            <TableRow key={winner.id}>
              <TableCell className="whitespace-nowrap">
                {formatDate(winner.created_at, true)}
              </TableCell>
              <TableCell>{winner.prizes?.name || 'Unknown prize'}</TableCell>
              <TableCell>
                {winner.vote_content || winner.tips?.content || 'No vote/tip'}
              </TableCell>
              <TableCell>{winner.source || 'Unknown source'}</TableCell>
              <TableCell>
                <div className="max-w-xs overflow-hidden text-ellipsis">
                  {formatDeviceInfo(winner.device_info)}
                </div>
              </TableCell>
              <TableCell>
                <span className={`px-2 py-1 rounded-full text-sm ${
                  winner.claimed 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {winner.claimed ? "Claimed" : "Unclaimed"}
                </span>
              </TableCell>
              <TableCell>
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => onDelete(winner.id)}
                  disabled={deletingId === winner.id}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
